module.exports = __webpack_public_path__ + "static/media/IKEA.2681f67e.svg";